import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
@Component({
  selector: 'app-hca-loyalty-website-main',
  templateUrl: './hca-loyalty-website-main.component.html',
  styleUrls: ['./hca-loyalty-website-main.component.scss']
})
export class HcaLoyaltyWebsiteMainComponent implements OnInit {
  public reset: any[] = [{}];
  hotelBrands: any[] = [];
  selectedBrand: any;

  constructor(
    public translate: TranslateService,
    private loyaltyService: LoyaltyService,
    private hotelManagementService: HotelManagementService,
    private hcaUserManagementService: HcaUserManagementService
  ) {
    this.getHotelBrandsByHotelChain();
    let user = JSON.parse(localStorage.getItem('loggedInUser'));
    translate.setDefaultLang('en');
    translate.use('en');
  }
  changeTabs() {
    this.reset[0] = {};
  }

  getHotelBrandsByHotelChain() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {
        if (res.error == 0) {
          this.hotelBrands = res.responseObj;
          if (res.responseObj.length > 0) {
            this.hotelManagementService.setSelectedBrand(res.responseObj[0]);
            let brandSelected = this.hotelManagementService.getSelectedBrand();
            this.selectedBrand = brandSelected ? brandSelected : res.responseObj[0];
          }
        }
        else {
          console.error("Get Hotel Brands : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  selectBrand(brand) {
    this.selectedBrand = brand;
    this.hotelManagementService.setSelectedBrand(brand);
    this.loyaltyService.brandInfo(brand);
  }

  ngOnInit() {
    this.getHotelBrandsByHotelChain();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/hca-loyalty-website-main/hca-loyalty-website-main.component.ts